const localization = LOCALIZATION;

export default localization;


// WEBPACK FOOTER //
// ./data/localization.js